// extracted by mini-css-extract-plugin
export var ClearFix = "SlideInRight-module--ClearFix--8PegV";
export var FloatArea = "SlideInRight-module--FloatArea--1Hij_";
export var slideInItem = "SlideInRight-module--slideInItem--2DXKT";
export var slideIn = "SlideInRight-module--slideIn--mir3R";
export var slideInShow = "SlideInRight-module--slideInShow--2E2eH";